// extracted by mini-css-extract-plugin
export default {"dot":"_3b0kP","active":"_3K_3m","container":"FvDLr"};